module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"products":{"comparison_list":{"empty":"Your comparison list is empty. Add up to 10 products to your comparison list by using the checkbox.","start_comparison":"Start fund comparison","toggle":"Comparison list (%{count}/%{max})"}}}}}}')
  delete Component.options._Ctor
}
